/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */

export const WORK_STATUS = {
    READY: 'ready',
    WORKING: 'working',
    COMPLETE: 'completed',
};

export const WORK_STATUS_ACTIONS = {
    [WORK_STATUS.READY]: {
        name: 'check_in',
    },

    [WORK_STATUS.WORKING]: {
        name: 'check_out',
    },

    [WORK_STATUS.COMPLETE]: {
        name: 'update_check_out',
    },
};
